/* eslint-disable max-len */
/* eslint-disable no-unused-expressions */
/* eslint-disable radix */
import { saveAs } from 'file-saver';
import XLSX from 'tempa-xlsx';
import { min2time } from '../../../helpers/utils';
import { strToArrBuffer } from './DataUtil';
import exportsFormulas from '../exportsFormulas';

function formatRattrapageData(dataPdf, elearningDuration, elearningTarget, elearningAttempts, elearningDurationTarget) {
  const finalData = [];

  if (dataPdf.rattrapage !== null && dataPdf.rattrapage !== undefined) {
    dataPdf.rattrapage.data.forEach((element) => {
      let obj = {};
      // si export avant le 17/01/2024 ou appartient à lons-le-saunier, mauvaise formule, sinon bonne formule
      if ((dataPdf.exportData.companyId === '64d09984b6d5020026b996c6' && new Date(dataPdf.exportData.updated_at) < new Date('2024-01-17')) || (new Date(dataPdf.exportData.updated_at) < new Date('2024-01-17'))) {
        obj = exportsFormulas.flawedRattrapageFormula(element, elearningTarget, elearningAttempts, elearningDuration / 60);
        const rowData = [];
        rowData.push({ value: element.name });
        rowData.push({ value: element.firstname });
        (obj.quizPercent < obj.quizTarget)
          ? rowData.push({ value: `${Math.floor(element.percent)}%`, style: { fill: { patternType: 'solid', fgColor: { rgb: 'FFFF5959' } } } })
          : rowData.push({ value: `${Math.floor(element.percent)}%` });
        (obj.unitsPercent < obj.unitsTarget)
          ? rowData.push({ value: `${Math.floor(element.unitsPercent)}%`, style: { fill: { patternType: 'solid', fgColor: { rgb: 'FFFF5959' } } } })
          : rowData.push({ value: `${Math.floor(element.unitsPercent)}%` });
        (obj.timeNote < 10 && elearningDurationTarget && elearningDurationTarget > 0)
          ? rowData.push({ value: min2time(element.time), style: { fill: { patternType: 'solid', fgColor: { rgb: 'FFFF5959' } } } })
          : rowData.push({ value: min2time(element.time) });
        rowData.push({ value: obj.note.toFixed(2) });
        finalData.push(rowData);
      } else {
        obj = exportsFormulas.rattrapageFormula(element, elearningTarget, elearningAttempts, elearningDuration);
        const rowData = [];
        rowData.push({ value: element.name });
        rowData.push({ value: element.firstname });
        element.quizPercent < elearningTarget
          ? rowData.push({ value: `${Math.floor(element.percent)}%`, style: { fill: { patternType: 'solid', fgColor: { rgb: 'FFFF5959' } } } })
          : rowData.push({ value: `${Math.floor(element.percent)}%` });
        element.unitsPercent < elearningAttempts
          ? rowData.push({ value: `${Math.floor(element.unitsPercent)}%`, style: { fill: { patternType: 'solid', fgColor: { rgb: 'FFFF5959' } } } })
          : rowData.push({ value: `${Math.floor(element.unitsPercent)}%` });
        element.time < elearningDuration
          ? rowData.push({ value: min2time(element.time), style: { fill: { patternType: 'solid', fgColor: { rgb: 'FFFF5959' } } } })
          : rowData.push({ value: min2time(element.time) });
        rowData.push({ value: obj.note.toFixed(2) });
        finalData.push(rowData);
      }
    });
  }

  const style = { font: { bold: true }, fill: { patternType: 'solid', fgColor: { rgb: 'FF5972FF' } } };
  return [{
    columns: [
      { title: 'Nom', width: { wch: 20 }, style },
      { title: 'Prenom', width: { wch: 20 }, style },
      { title: `Réussite aux quizs (${elearningTarget}%)`, width: { wch: 25 }, style },
      { title: `Réalisation du programme (${elearningAttempts}%)`, width: { wch: 25 }, style },
      { title: `Temps de connexion (${min2time(elearningDuration)})`, width: { wch: 20 }, style },
      { title: 'Note (/20)', width: { wch: 20 }, style },
    ],
    data: finalData,
  }];
}

function formatSuccessData(dataPdf, elearningDuration, elearningTarget, elearningAttempts, elearningDurationTarget) {
  const finalData = [];

  if (dataPdf.success !== null && dataPdf.success !== undefined) {
    dataPdf.success.data.forEach((element) => {
      let obj = 0;
      // si export avant le 17/01/2024 ou appartient à lons-le-saunier, mauvaise formule, sinon bonne formule
      if ((dataPdf.exportData.companyId === '64d09984b6d5020026b996c6' && new Date(dataPdf.exportData.updated_at) < new Date('2024-01-17')) || (new Date(dataPdf.exportData.updated_at) < new Date('2024-01-17'))) {
        obj = exportsFormulas.flawedSuccessFormula(element, elearningTarget, elearningAttempts, elearningDuration / 60, elearningDurationTarget);
      } else {
        obj = exportsFormulas.successFormula(element, elearningTarget, elearningAttempts, elearningDuration);
      }
      const rowData = [];

      rowData.push({ value: element.name });
      rowData.push({ value: element.firstname });
      rowData.push({ value: `${Math.floor(element.percent)}%` });
      rowData.push({ value: `${Math.floor(element.unitsPercent)}%` });
      rowData.push({ value: min2time(element.time) });
      rowData.push({ value: obj.note.toFixed(2) });
      finalData.push(rowData);
    });
  }
  const style = { font: { bold: true }, fill: { patternType: 'solid', fgColor: { rgb: 'FF21B12E' } } };
  return [{
    columns: [
      { title: 'Nom', width: { wch: 20 }, style },
      { title: 'Prenom', width: { wch: 20 }, style },
      { title: `Réussite aux quizs (${elearningTarget}%)`, width: { wch: 25 }, style },
      { title: `Réalisation du programme (${elearningAttempts}%)`, width: { wch: 25 }, style },
      { title: `Temps de connexion (${min2time(elearningDuration)})`, width: { wch: 20 }, style },
      { title: 'Note (/20)', width: { wch: 20 }, style },
    ],
    data: finalData,
  }];
}

function formatNoTrackData(dataPdf) {
  const finalData = [];
  if (dataPdf.csvnotrack !== null && dataPdf.csvnotrack !== undefined) {
    dataPdf.csvnotrack.data.forEach((element) => {
      const rowData = [];
      rowData.push({ value: element.name });
      rowData.push({ value: element.firstname });
      rowData.push({ value: element.email });
      finalData.push(rowData);
    });
  }

  return [{
    columns: [
      { title: 'Nom', width: { wch: 20 }, style: { font: { bold: true }, fill: { patternType: 'solid', fgColor: { rgb: 'FFFF0000' } } } },
      { title: 'Prenom', width: { wch: 20 }, style: { font: { bold: true }, fill: { patternType: 'solid', fgColor: { rgb: 'FFFF0000' } } } },
      { title: 'Email', width: { wch: 40 }, style: { font: { bold: true }, fill: { patternType: 'solid', fgColor: { rgb: 'FFFF0000' } } } },
    ],
    data: finalData,
  }];
}

function generateExcel(wb, name) {
  const fileType = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';

  const excelBuffer = XLSX.write(wb, { bookType: 'xlsx', type: 'binary' });
  saveAs(new Blob([strToArrBuffer(excelBuffer)], { type: fileType }), name);
}

const excelGen = {
  formatNoTrackData, formatRattrapageData, formatSuccessData, generateExcel,
};

export default excelGen;
